import apiFetch from "@wordpress/api-fetch";

declare global {
  interface Window {
    cyA11yGlobals: {
      api: {
        endpoint: string;
        nonce: string;
        nonce_name?: string;
      };
    };
  }
}

apiFetch.use(apiFetch.createNonceMiddleware(window.cyA11yGlobals.api.nonce));
apiFetch.use(
  apiFetch.createRootURLMiddleware(window.cyA11yGlobals.api.endpoint)
);

export interface ApiOptions {
  path: string;
  params?: Record<string, string | number | boolean>;
  data?: unknown;
  [key: string]: unknown;
}

const toStringParams = (params: Record<string, string | number | boolean>) =>
  Object.entries(params).map(([key, value]) => [key, String(value)]);

const api = {
  post: async (options: ApiOptions) => {
    const opts = { ...options, method: "POST" };
    if (opts.params) {
      const urlParams = new URLSearchParams(toStringParams(opts.params));
      opts.path = `${opts.path}?${urlParams}`;
    }
    try {
      return await apiFetch(opts);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  get: async (options: ApiOptions) => {
    const opts = { ...options, method: "GET" };
    if (opts.params) {
      const urlParams = new URLSearchParams(toStringParams(opts.params));
      opts.path = `${opts.path}?${urlParams}`;
    }
    try {
      return await apiFetch(opts);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  put: async (options: ApiOptions) => {
    const opts = { ...options, method: "PUT" };
    if (opts.params) {
      const urlParams = new URLSearchParams(toStringParams(opts.params));
      opts.path = `${opts.path}?${urlParams}`;
    }
    try {
      return await apiFetch(opts);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  delete: async (options: ApiOptions) => {
    const opts = { ...options, method: "DELETE" };
    try {
      return await apiFetch(opts);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default api;
